//#region IMPORT
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { NavBarInfoActions } from '../../../Reducer/NavBarInfoReducer';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';
import M_WOE_BASIC_02 from './M_WOE_BASIC_02';
import { useSearch1, useSave1 } from './M_WOE_BASIC_02_Query';
import { useSave } from '../../../Hooks/useSave';
import useFileUpload from '../../../Hooks/useFileUpload';
import { WOE_BASIC_02_Schema } from './M_WOE_BASIC_02_Schema';
import { useAppNavigate } from '../../../Hooks/back/useAppNavigate';
import { useBackStack } from '../../../Hooks/back/useBackStack';
//#endregion

const INPUTS = {
  afterComment: '',
};

function M_WOE_BASIC_02F() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { navigate } = useAppNavigate();
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const [rowData1, setRowData1] = useState({});
  const [beforeImageList, setBeforeImageList] = useState([]);
  const [afterImageList, setAfterImageList] = useState([]);
  const [workEndInputs, setWorkEndInputs] = useState(INPUTS);
  const [errors, setErrors] = useState({});
  const [custInputs, setCustInputs] = useState({ custCd: '', custList: [] });

  const workEndUpload = useFileUpload({
    oldFilePathField: 'image',
    newFileNameField: 'saveName',
    maxCount: 5,
    getTargetPath: () =>
      `WorkEnd/${custInputs.custCd}/WOE_BASIC_02/${rowData1?.DEP_CD ?? userInfo.depCd}`,
  });

  useEffect(() => {
    Init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // 스택형 뒤로가기로 변경: 작업 종료 상세에서는 목록으로 복귀
  useBackStack({
    type: 'navigate',
    onBack: () => navigate('/M_WorkEnd'),
  });

  const Init = () => {
    dispatch(NavBarInfoActions.setType('titleBar'));
    dispatch(NavBarInfoActions.setTitleName('작업 종료'));
    Search1Async({ workCd: id });
  };

  //#region 쿼리
  const { runAsync: Search1Async } = useSearch1({
    onSuccess: (rows) => {
      if (!rows?.length || rows[0]?.type === 'Error') {
        if (rows?.[0]?.message)
          dispatch(showSnackbar({ message: rows[0].message, type: 'error' }));
        setRowData1({});
        setBeforeImageList([]);
        setAfterImageList([]);
        return;
      }
      const data = rows[0];
      setRowData1(data);
      if (data?.BEFORE_IMAGE || data?.beforeImage) {
        const images = (data.BEFORE_IMAGE || data.beforeImage || '')
          .split(',')
          .map((url) => url.trim())
          .filter((url) => url);
        setBeforeImageList(images);
      } else {
        setBeforeImageList([]);
      }
      if (data?.AFTER_IMAGE || data?.afterImage) {
        const afterImages = (data.AFTER_IMAGE || data.afterImage || '')
          .split(',')
          .map((url) => url.trim())
          .filter((url) => url);
        setAfterImageList(afterImages);
      } else {
        setAfterImageList([]);
      }
      if (data?.CUST_CD || data?.custCd) {
        setCustInputs((prev) => ({
          ...prev,
          custCd: data.CUST_CD || data.custCd,
        }));
      }
    },
  });

  const { runAsync: Save1Async } = useSave1();
  //#endregion

  //#region 저장
  const { run: Save1 } = useSave({
    menuId: 'M_WOE_BASIC_02',
    schema: WOE_BASIC_02_Schema,
    saveData: () => ({
      workCd: id,
      afterComment: workEndInputs.afterComment ?? '',
      afterImage: '',
    }),
    requestSave: async (rows) => {
      const row = rows[0] ?? {};
      const res = await Save1Async({
        row: { ...row, afterImage: '' },
        userInfo,
      });

      let afterImage = '';
      if (workEndUpload.previewList.filter((img) => !img.deleted).length > 0) {
        afterImage = (await workEndUpload.SaveLogicFile()) || '';
        await Save1Async({
          row: {
            ...row,
            afterImage,
          },
          userInfo,
        });
      }

      dispatch(
        showSnackbar({
          message: '개선 사항이 저장되었습니다.',
          type: 'success',
        })
      );

      await Search1Async({ workCd: id });
      setWorkEndInputs({ afterComment: '' });
      workEndUpload.clearFiles();
      return res;
    },
  });
  //#endregion

  return (
    <div className="wrap">
      <M_WOE_BASIC_02
        id={id}
        userInfo={userInfo}
        rowData1={rowData1}
        beforeImageList={beforeImageList}
        afterImageList={afterImageList}
        FileChange={workEndUpload.FileChange}
        SaveLogic1={Save1}
        ValidateAll={() => {
          const requiredFields = ['afterComment'];
          const fieldLabels = {
            afterComment: '내용',
          };
          let newErrors = {};
          let hasError = false;
          requiredFields.forEach((field) => {
            const msg =
              (workEndInputs[field] || '').trim() === ''
                ? `${fieldLabels[field]}을 입력하세요.`
                : '';
            newErrors[field] = msg;
            if (msg) hasError = true;
          });
          setErrors(newErrors);
          return !hasError;
        }}
        DeletePreview={workEndUpload.DeletePreview}
        setWorkEndInputs={setWorkEndInputs}
        workEndInputs={workEndInputs}
        errors={errors}
        setErrors={setErrors}
        previewList={workEndUpload.previewList}
        clearFiles={workEndUpload.clearFiles}
      />
    </div>
  );
}

export default M_WOE_BASIC_02F;
